import React, { useEffect, useMemo } from 'react';
import { useMediaQuery } from 'react-haiku';
import classnames from 'classnames';

import Page from 'components/Misc/Navigation/Page';
import Theme from 'components/Misc/Navigation/Theme';

import { useAppStore } from 'store/useAppStore';

const getPages = (role) => {
	switch (role) {
	case 'admin':
		return [
			{ text: 'Vispārīgi'},
			{ url: '/', icon: 'home', text: 'Sākums' },
			{ url: '/articles', icon: 'article', text: 'Aktualitātes'},
			{ url: '/documents', icon: 'description', text: 'Dokumenti'},
			{ url: '/users', icon: 'people', text: 'Lietotāji' },
			{ text: 'Mācības' },
			{ url: '/programs', icon: 'category', text: 'Programmas' },
			{ url: '/grades', icon: 'widgets', text: 'Klases' },
			{ url: '/blanks', icon: 'folder_special', text: 'Sagataves' },
			{ url: '/subjects', icon: 'bookmark_border', text: 'Kursi' },
			{ url: '/courses', icon: 'book', text: 'Moduļi' },
			{ url: '/materials', icon: 'chrome_reader_mode', text: 'Materiāli' },
			{ url: '/exams', icon: 'assignment', text: 'Pārbaudes darbi' },
			{ url: '/results', icon: 'summarize', text: 'Rezultāti' },
			{ url: '/webinars', icon: 'voice_chat', text: 'Vebināri' },
			{ url: '/finals', icon: 'star', text: 'Eksāmeni' },
			{ text: 'Sistēma' },
			{ url: '/logs', icon: 'bug_report', text: 'Paziņojumi' }
		];
	case 'employee':
		return [
			{ text: 'Vispārīgi'},
			{ url: '/', icon: 'home', text: 'Sākums' },
			{ url: '/articles', icon: 'article', text: 'Aktualitātes'},
			{ url: '/documents', icon: 'description', text: 'Dokumenti'},
			{ url: '/users', icon: 'people', text: 'Lietotāji' },
			{ text: 'Mācības' },
			{ url: '/programs', icon: 'category', text: 'Programmas' },
			{ url: '/grades', icon: 'widgets', text: 'Klases' },
			{ url: '/blanks', icon: 'folder_special', text: 'Sagataves' },
			{ url: '/subjects', icon: 'bookmark_border', text: 'Kursi' },
			{ url: '/courses', icon: 'book', text: 'Moduļi' },
			{ url: '/materials', icon: 'chrome_reader_mode', text: 'Materiāli' },
			{ url: '/exams', icon: 'assignment', text: 'Pārbaudes darbi' },
			{ url: '/results', icon: 'summarize', text: 'Rezultāti' },
			{ url: '/webinars', icon: 'voice_chat', text: 'Vebināri' },
			{ url: '/finals', icon: 'star', text: 'Eksāmeni' }
		];
	case 'teacher':
		return [
			{ text: 'Vispārīgi'},
			{ url: '/', icon: 'home', text: 'Sākums' },
			{ url: '/articles', icon: 'article', text: 'Aktualitātes' },
			{ url: '/users', icon: 'people', text: 'Studenti' },
			{ text: 'Mācības' },
			{ url: '/subjects', icon: 'bookmark_border', text: 'Kursi' },
			{ url: '/courses', icon: 'book', text: 'Moduļi' },
			{ url: '/materials', icon: 'chrome_reader_mode', text: 'Materiāli' },
			{ url: '/exams', icon: 'assignment', text: 'Pārbaudes darbi' },
			{ url: '/webinars', icon: 'voice_chat', text: 'Vebināri' }
		];
	case 'student':
		return [
			{ url: '/', icon: 'home', text: 'Sākums' },
			{ url: '/articles', icon: 'article', text: 'Aktualitātes' },
			{ url: '/subjects', icon: 'bookmark_border', text: 'Kursi' },
			// { url: '/courses', icon: 'book', text: 'Moduļi' },
			{ url: '/webinars', icon: 'voice_chat', text: 'Vebināri' },
			{ url: '/exams', icon: 'assignment', text: 'Pārbaudes darbi' },
			{ url: '/marks', icon: 'grade', text: 'Sekmes' },
			{ url: '/payments', icon: 'shopping_cart', text: 'Maksājumi' }
		];
	case 'parent':
		return [
			{ url: '/', icon: 'home', text: 'Sākums' },
			{ url: '/articles', icon: 'article', text: 'Aktualitātes' },
			// { url: '/courses', icon: 'book', text: 'Moduļi' },
			// { url: '/webinars', icon: 'voice_chat', text: 'Vebināri' },
			// { url: '/exams', icon: 'assignment', text: 'Pārbaudes darbi' },
			{ url: '/marks', icon: 'grade', text: 'Sekmes' },
			{ url: '/payments', icon: 'shopping_cart', text: 'Maksājumi' }
		];
	default:
		return [];
	}
};

const Navigation = () => {
	// User app's store
	const [user, navigation, setNavigation] = useAppStore(state => [state.user, state.navigation, state.setNavigation]);

	// Check if viewing from mobile
	const isMobile = useMediaQuery('(max-width: 768px)');

	// Create navigation's menu structure according to user's role
	const pages = useMemo(() => getPages(user.role), [user.role]);

	// Concat classnames
	const cls = classnames(
		'fixed top-14 bottom-0 z-10 flex flex-col items-start w-full max-w-[260px] overflow-x-hidden overflow-y-auto bg-white transition-all',
		'dark:bg-neutral-800',
		navigation && 'left-0',
		!navigation && '-left-full'
	);

	// Toggle navigation based on view size
	useEffect(() => setNavigation(!isMobile), [isMobile]);

	return (
		<nav className={cls}>
			{/* User's page list */}
			<div className="flex flex-col w-full flex-1">
				{pages?.map(page =>
					<Page key={page.text} page={page} />
				)}
			</div>
			
			{/* Theme toggle */}
			<Theme />
		</nav>
	);
};

export default Navigation;